module.exports = __webpack_public_path__ + "static/media/usa.173eb30e.svg";